import {
	RUNNIT_NODE_DEF_TOOL_TYPE,
	RUNNIT_NODE_DEF_PROVIDER,
} from '@run-diffusion/shared';

interface DROPDOWN_ITEM {
	id: string | null;
	name: string;
}

export const PROVIDER_ITEMS: DROPDOWN_ITEM[] = [
	{
		id: null,
		name: '---',
	},
	{
		id: RUNNIT_NODE_DEF_PROVIDER.RUNNIT_IMG,
		name: '"Runnit" branded image generation pipelines',
	},
	{
		id: RUNNIT_NODE_DEF_PROVIDER.RD,
		name: 'RunDiffusion',
	},
	{
		id: RUNNIT_NODE_DEF_PROVIDER.OCTOAI,
		name: 'octo.ai',
	},
	{
		id: RUNNIT_NODE_DEF_PROVIDER.RUNPOD,
		name: 'RunPod',
	},
	{
		id: RUNNIT_NODE_DEF_PROVIDER.IDEOGRAM,
		name: 'Ideogram',
	},
	{
		id: RUNNIT_NODE_DEF_PROVIDER.FALAI,
		name: 'FAL.ai',
	},
	{
		id: RUNNIT_NODE_DEF_PROVIDER.MODAL,
		name: 'Modal',
	},
	{
		id: RUNNIT_NODE_DEF_PROVIDER.NICHETENSOR,
		name: 'NicheTensor',
	},
	{
		id: RUNNIT_NODE_DEF_PROVIDER.RUNWAY,
		name: 'RunwayML',
	},
	{
		id: RUNNIT_NODE_DEF_PROVIDER.LUMAAI,
		name: 'Lumaai',
	},
	{
		id: RUNNIT_NODE_DEF_PROVIDER.KLINGAI,
		name: 'Klingai',
	},
	{
		id: RUNNIT_NODE_DEF_PROVIDER.RUNWARE,
		name: 'Runware',
	},
	{
		id: RUNNIT_NODE_DEF_PROVIDER.OPENAI,
		name: 'OpenAI',
	},
	{
		id: RUNNIT_NODE_DEF_PROVIDER.TOPAZ,
		name: 'Topaz',
	},
	{
		id: RUNNIT_NODE_DEF_PROVIDER.FREEPIK,
		name: 'Freepik',
	},
	{
		id: RUNNIT_NODE_DEF_PROVIDER.KIEAI,
		name: 'Kie.ai',
	},
	{
		id: RUNNIT_NODE_DEF_PROVIDER.VERTEX,
		name: 'Vertex AI',
	},
];

export const NODE_TYPE_ITEMS: DROPDOWN_ITEM[] = [
	{
		id: null,
		name: '---',
	},
	{
		id: RUNNIT_NODE_DEF_TOOL_TYPE.CORE,
		name: 'Core',
	},
	{
		id: RUNNIT_NODE_DEF_TOOL_TYPE.COMPANY,
		name: 'Company',
	},
];

export const ENDPOINT_ID_ITEMS: Record<string, DROPDOWN_ITEM[]> = {
	[RUNNIT_NODE_DEF_PROVIDER.RUNNIT_IMG]: [
		{
			id: null,
			name: '---',
		},
		{
			id: 'runnit-img-gen-1',
			name: 'Runnit Apex (Image Gen)',
		},
	],
	[RUNNIT_NODE_DEF_PROVIDER.RD]: [
		{
			id: null,
			name: '---',
		},
		{
			id: 'cmfy-workflow',
			name: '(COMFY) Default Comfy Workflow',
		},
		{
			id: 'mood-board',
			name: 'Mood Board',
		},
	],
	[RUNNIT_NODE_DEF_PROVIDER.FALAI]: [
		{
			id: null,
			name: '---',
		},
		{
			id: 'hunyuan-custom',
			name: 'Hunyuan Custom',
		},
		{
			id: 'imagen4',
			name: 'Google Imagen 4',
		},
		{
			id: 'gpt-image-edit',
			name: 'GPT Image Edit',
		},
		{
			id: 'gpt-moodboard',
			name: 'GPT Moodboard',
		},
		{
			id: 'magi-distilled',
			name: 'MAGI-1 (Distilled) Text to Video',
		},
		{
			id: 'hidream-i1-fast',
			name: 'HiDream I1 Fast',
		},
		{
			id: 'hidream-i1-dev',
			name: 'HiDream I1 Dev',
		},
		{
			id: 'hidream-i1-full',
			name: 'HiDream I1 Full',
		},
		{
			id: 'any-sd',
			name: 'Any Stable Diffusion',
		},
		{
			id: 'creative-upscaler',
			name: 'Creative Upscaler',
		},
		{
			id: 'aura-sr-upscaler',
			name: 'AuraSR Upscaler',
		},
		{
			id: 'easel-face-swap',
			name: 'Easel Face Swap',
		},
		{
			id: 'stable-diffusion-xl',
			name: 'Stable Diffusion XL',
		},
		{
			id: 'stable-diffusion-v35-large',
			name: 'Stable Diffusion v3.5 Large',
		},
		{
			id: 'remove-background',
			name: 'Remove Background',
		},
		{
			id: 'remove-background-birefnet',
			name: 'Remove Background Birefnet',
		},
		{
			id: 'ddcolor',
			name: 'DDColor',
		},
		{
			id: 'codeformer',
			name: 'CodeFormer',
		},
		{
			id: 'leffa-tryon',
			name: 'Leffa Virtual TryOn',
		},
		{
			id: 'fashn-tryon',
			name: 'Fashn Virtual TryOn v1.5',
		},
		{
			id: 'gemini-flash-edit',
			name: 'Gemini Flash Edit',
		},
		{
			id: 'ccsr',
			name: 'CCSR',
		},
		{
			id: 'bria-eraser',
			name: 'Bria Eraser',
		},
		{
			id: 'bria-expand',
			name: 'Bria Expand',
		},
		{
			id: 'bria-product-shot',
			name: 'Bria Product Shot',
		},
		{
			id: 'bria-video-background-removal',
			name: 'Bria Video Background Removal',
		},
		{
			id: 'birefnet-v2-video',
			name: 'BiRefNet V2 Video Background Removal',
		},
		{
			id: 'cartoonify',
			name: 'Cartoonify',
		},
		{
			id: 'flux-dev',
			name: 'Flux Dev',
		},
		{
			id: 'flux-dev-with-loras',
			name: 'Flux Dev with LoRAs',
		},
		{
			id: 'flux-dev-fill-with-loras',
			name: 'Flux Dev Fill with LoRAs',
		},
		{
			id: 'flux-pro',
			name: 'Flux Pro',
		},
		{
			id: 'flux-pro-1-1',
			name: 'Flux Pro 1.1 (Blueberry)',
		},
		{
			id: 'flux-pro-v1-1-redux',
			name: 'Flux Pro 1.1 Redux',
		},
		{
			id: 'flux-pro-v1-canny',
			name: 'Flux Pro Canny',
		},
		{
			id: 'flux-pro-v1-depth',
			name: 'Flux Pro Depth',
		},
		{
			id: 'flux-pro-v1-fill',
			name: 'Flux Pro Fill',
		},
		{
			id: 'flux-pro-v1-redux',
			name: 'Flux Pro Redux',
		},
		{
			id: 'flux-pro-v1-1-ultra',
			name: 'Flux Pro Ultra',
		},
		{
			id: 'flux-pro-v1-1-ultra-redux',
			name: 'Flux Pro Ultra Redux',
		},
		{
			id: 'flux-2-flex',
			name: 'Flux 2 Flex',
		},
		{
			id: 'flux-2',
			name: 'Flux 2',
		},
		{
			id: 'flux-2-pro',
			name: 'Flux 2 Pro',
		},
		{
			id: 'flux-schnell',
			name: 'Flux Schnell',
		},
		{
			id: 'flux-lora-fast-training',
			name: 'Flux LoRa Fast Training',
		},
		{
			id: 'turbo-flux-trainer',
			name: 'Turbo Flux Trainer',
		},
		{
			id: 'flux-lora-depth',
			name: 'Flux LoRa Depth',
		},
		{
			id: 'flux-lora-canny',
			name: 'Flux LoRa Canny',
		},
		{
			id: 'flux-pulid',
			name: 'Flux PuLID',
		},
		{
			id: 'flux-subject',
			name: 'Flux Subject',
		},
		{
			id: 'instant-character',
			name: 'Instant Character',
		},
		{
			id: 'plushify',
			name: 'Plushify',
		},
		{
			id: 'runway-gen-3-turbo',
			name: 'Runway Gen3 (turbo)',
		},
		{
			id: 'recraft-v3',
			name: 'Recraft v3',
		},
		{
			id: 'recraft-v4-vector',
			name: 'Recraft v4 Vector',
		},
		{
			id: 'recraft-v4-vector-pro',
			name: 'Recraft v4 Vector Pro',
		},
		{
			id: 'recraft-upscale',
			name: 'Recraft Upscale (Crisp/Creative)',
		},
		{
			id: 'patina',
			name: 'Patina PBR Maps',
		},
		{
			id: 'juggernaut-base-flux',
			name: 'Juggernaut Base Flux',
		},
		{
			id: 'juggernaut-base-flux-lora',
			name: 'Juggernaut Base Flux with LoRA',
		},
		{
			id: 'juggernaut-base-flux-redux',
			name: 'Juggernaut Base Flux Redux',
		},
		{
			id: 'juggernaut-pro-flux',
			name: 'Juggernaut Pro Flux',
		},
		{
			id: 'juggernaut-pro-flux-redux',
			name: 'Juggernaut Pro Flux Redux',
		},
		{
			id: 'juggernaut-lightning-flux',
			name: 'Juggernaut Lightning Flux',
		},
		{
			id: 'juggernaut-lightning-flux-redux',
			name: 'Juggernaut Lightning Flux Redux',
		},
		{
			id: 'kling-standard-1-0',
			name: 'Kling 1.0 (standard)',
		},
		{
			id: 'kling-standard-1-6',
			name: 'Kling 1.6 (standard)',
		},
		{
			id: 'kling-16-std-elements',
			name: 'Kling 1.6 Standard Elements',
		},
		{
			id: 'kling-pro-1-0',
			name: 'Kling 1.0 (pro)',
		},
		{
			id: 'kling-pro-1-5',
			name: 'Kling 1.5 (pro)',
		},
		{
			id: 'kling-pro-1-6',
			name: 'Kling 1.6 (pro)',
		},
		{
			id: 'kling-16-pro-elements',
			name: 'Kling 1.6 Pro Elements',
		},
		{
			id: 'kling-2-master',
			name: 'Kling 2.0 Master',
		},
		{
			id: 'kling-2-1-std',
			name: 'Kling 2.1 Standard',
		},
		{
			id: 'kling-2-1-pro',
			name: 'Kling 2.1 Pro',
		},
		{
			id: 'kling-2-1-master',
			name: 'Kling 2.1 Master',
		},
		{
			id: 'kling-o1-start-end-frame',
			name: 'Kling O1 Start-End Frame',
		},
		{
			id: 'kling-o1-reference-image',
			name: 'Kling O1 Reference Image',
		},
		{
			id: 'kling-o1-video-to-video',
			name: 'Kling O1 Video to Video',
		},
		{
			id: 'kling-o1-reference-video',
			name: 'Kling O1 Reference Video',
		},
		{
			id: 'minimax-video',
			name: 'MiniMax Video',
		},
		{
			id: 'minimax-h3',
			name: 'MiniMax H3',
		},
		{
			id: 'minimax-h3-ref-to-vid',
			name: 'MiniMax H3 Ref. to Video',
		},
		{
			id: 'minimax-h3-max',
			name: 'MiniMax H3 Max',
		},
		{
			id: 'minimax-h3-max-ref-to-vid',
			name: 'MiniMax H3 Max Ref. to Video',
		},
		{
			id: 'minimax-h3-max-recast',
			name: 'MiniMax H3 Max Recast',
		},
		{
			id: 'minimax-h3-max-reframe',
			name: 'MiniMax H3 Max Reframe',
		},
		{
			id: 'flux-3-video',
			name: 'Flux 3 Video',
		},
		{
			id: 'flux-3-max-video',
			name: 'Flux 3 Max Video',
		},
		{
			id: 'flux-3-extend-video',
			name: 'Flux 3 Extend Video',
		},
		{
			id: 'flux-3-edit-video',
			name: 'Flux 3 Edit Video',
		},
		{
			id: 'flux-3-video-upscale',
			name: 'Flux 3 Video Upscale',
		},
		{
			id: 'flux-3-draft-video',
			name: 'Flux 3 Draft Video',
		},
		{
			id: 'flux-3-draft-extend-video',
			name: 'Flux 3 Draft Extend Video',
		},
		{
			id: 'flux-3-image',
			name: 'Flux 3 Image',
		},
		{
			id: 'flux-3-klein',
			name: 'Flux 3 Klein',
		},
		{
			id: 'flux-3-klein-base',
			name: 'Flux 3 Klein Base',
		},
		{
			id: 'hunyuan-video',
			name: 'Hunyuan Video',
		},
		{
			id: 'luma-dream-machine',
			name: 'Luma Dream Machine',
		},
		{
			id: 'luma-dream-machine-ray-2',
			name: 'Luma Dream Machine Ray 2',
		},
		{
			id: 'luma-ray-v3-2',
			name: 'Luma Ray 3.2',
		},
		{
			id: 'luma-ray-v3-2-video-edit',
			name: 'Luma Ray 3.2 Video Edit',
		},
		{
			id: 'luma-ray-v3-2-reframe',
			name: 'Luma Ray 3.2 Reframe',
		},
		{
			id: 'veo2',
			name: 'Veo2',
		},
		{
			id: 'veo3',
			name: 'Veo3',
		},
		{
			id: 'veo3-fast',
			name: 'Veo3 Fast',
		},
		{
			id: 'veo3.1',
			name: 'Veo3.1',
		},
		{
			id: 'veo3.1-fast',
			name: 'Veo3.1 Fast',
		},
		{
			id: 'veo3.1-extend',
			name: 'Veo3.1 Extend Video',
		},
		{
			id: 'veo3.1-fast-extend',
			name: 'Veo3.1 Fast Extend Video',
		},
		{
			id: 'gemini-omni-flash',
			name: 'Gemini Omni Flash',
		},
		{
			id: 'gemini-omni-flash-reference-video',
			name: 'Gemini Omni Flash Reference Video',
		},
		{
			id: 'gemini-omni-video-edit',
			name: 'Gemini Omni Video Edit',
		},
		{
			id: 'gemini-omni-flash-v1-1',
			name: 'Gemini Omni Flash 1.1',
		},
		{
			id: 'gemini-omni-flash-v1-1-reference-video',
			name: 'Gemini Omni Flash 1.1 Reference Video',
		},
		{
			id: 'gemini-omni-flash-v1-1-video-edit',
			name: 'Gemini Omni Flash 1.1 Video Edit',
		},
		{
			id: 'kling-2-5-turbo-pro',
			name: 'Kling 2.5 Turbo Pro',
		},
		{
			id: 'kling-2-6-pro',
			name: 'Kling 2.6 Pro',
		},
		{
			id: 'kling-3-standard',
			name: 'Kling 3.0 Standard',
		},
		{
			id: 'kling-3-pro',
			name: 'Kling 3.0 Pro',
		},
		{
			id: 'kling-3-4k',
			name: 'Kling 3.0 4K',
		},
		{
			id: 'kling-o3-standard',
			name: 'Kling o3 Standard',
		},
		{
			id: 'kling-o3-std-reference-image',
			name: 'Kling o3 Std Reference Image',
		},
		{
			id: 'kling-o3-std-reference-video',
			name: 'Kling o3 Std Reference Video',
		},
		{
			id: 'kling-o3-pro',
			name: 'Kling o3 Pro',
		},
		{
			id: 'kling-o3-4k',
			name: 'Kling o3 4K',
		},
		{
			id: 'kling-o3-pro-reference-image',
			name: 'Kling o3 Pro Reference Image',
		},
		{
			id: 'kling-o3-4k-reference-image',
			name: 'Kling o3 4K Reference Image',
		},
		{
			id: 'kling-o3-pro-reference-video',
			name: 'Kling o3 Pro Reference Video',
		},
		{
			id: 'kling-o3-4k-video-edit',
			name: 'Kling o3 4K Video Edit',
		},
		{
			id: 'kling-o3-4k-reference-video',
			name: 'Kling o3 4K Reference Video',
		},
		{
			id: 'kling-4',
			name: 'Kling 4.0',
		},
		{
			id: 'kling-4-reference-video',
			name: 'Kling 4.0 Reference Video',
		},
		{
			id: 'kling-4-video-edit',
			name: 'Kling 4.0 Video Edit',
		},
		{
			id: 'kling-image-v3',
			name: 'Kling Image V3',
		},
		{
			id: 'kling-image-o3',
			name: 'Kling Image o3',
		},
		{
			id: 'wan-video',
			name: 'Wan Video',
		},
		{
			id: 'wan-flf2v',
			name: 'Wan First-Last-Frame to Video',
		},
		{
			id: 'wan-pro',
			name: 'Wan Pro',
		},
		{
			id: 'wan-25',
			name: 'Wan 2.5',
		},
		{
			id: 'wan-25-image',
			name: 'Wan 2.5 (Image)',
		},
		{
			id: 'z-image-turbo',
			name: 'Z-Image Turbo',
		},
		{
			id: 'framepack',
			name: 'Framepack Image to Video',
		},
		{
			id: 'wan-effects',
			name: 'Wan Effects',
		},
		{
			id: 'pikaffects',
			name: 'Pikaffects',
		},
		{
			id: 'pika-2-2',
			name: 'Pika 2.2',
		},
		{
			id: 'skyreels-video',
			name: 'Skyreels Video',
		},
		{
			id: 'ltx-095-video',
			name: 'LTX 0.9.5 Video',
		},
		{
			id: 'ltx-097-video',
			name: 'LTX 0.9.7 Video',
		},
		{
			id: 'ltx-097-lora-video',
			name: 'LTX 0.9.7 LoRA Video',
		},
		{
			id: 'ltx-097-distilled-video',
			name: 'LTX 0.9.7 Distilled',
		},
		{
			id: 'ltx-098-distilled-video',
			name: 'LTX 0.9.8 Distilled'
		},
		{
			id: 'haiper-25',
			name: 'Haiper 2.5',
		},
		{
			id: 'cogvideo-5b',
			name: 'CogVideoX-5B',
		},
		{
			id: 'mochi-v1',
			name: 'Mochi v1 Video',
		},
		{
			id: 'transpixar',
			name: 'Transpixar Video',
		},
		{
			id: 'pixverse-video',
			name: 'Pixverse V3.5',
		},
		{
			id: 'pixverse-v4',
			name: 'Pixverse V4',
		},
		{
			id: 'pixverse-5-5',
			name: 'Pixverse 5.5',
		},
		{
			id: 'pixverse-effects',
			name: 'Pixverse Effects',
		},
		{
			id: 'pixverse-extend',
			name: 'Pixverse Extend',
		},
		{
			id: 'seedance-v1',
			name: 'Seedance V1',
		},
		{
			id: 'seedance-2.0',
			name: 'Seedance 2.0',
		},
		{
			id: 'seedance-2.0-fast',
			name: 'Seedance 2.0 Fast',
		},
		{
			id: 'seedance-2.0-mini',
			name: 'Seedance 2.0 Mini',
		},
		{
			id: 'seedance-2.0-reference-video',
			name: 'Seedance 2.0 Reference Video',
		},
		{
			id: 'seedance-2.0-fast-reference-video',
			name: 'Seedance 2.0 Fast Reference Video',
		},
		{
			id: 'seedance-2.5',
			name: 'Seedance 2.5',
		},
		{
			id: 'seedance-2.5-reference-video',
			name: 'Seedance 2.5 Reference Video',
		},
		{
			id: 'hailuo-2',
			name: 'Hailuo2 (MiniMax)',
		},
		{
			id: 'seedream-v3',
			name: 'Seedream V3 (Bytedance)',
		},
		{
			id: 'seedream-v4',
			name: 'Seedream V4 (Bytedance)',
		},
		{
			id: 'seedream-v5-pro',
			name: 'Seedream V5 Pro (Bytedance)',
		},
		{
			id: 'ideogram-v4',
			name: 'Ideogram v4',
		},
		{
			id: 'topaz-video-upscale',
			name: 'Topaz Video Upscale',
		},
		{
			id: 'kontext-max',
			name: 'Flux Kontext Max',
		},
		{
			id: 'kontext-dev',
			name: 'Flux Kontext Dev',
		},
		{
			id: 'bytedance-video-stylize',
			name: 'Bytedance Video Stylize',
		},
		{
			id: 'moonvalley-marey',
			name: 'Moonvalley Marey',
		},
		{
			id: 'qwen-image-edit',
			name: 'Qwen Image Edit',
		},
		{
			id: 'qwen-image-edit-2511',
			name: 'Qwen Image Edit 2511',
		},
		{
			id: 'qwen-image-edit-2511-multiple-angles',
			name: 'Qwen Image Edit 2511 Multiple Angles (Change camera)',
		},
		{
			id: 'sam2-segment-map',
			name: 'SAM 2 Segment Map (Find objects)',
		},
		{
			id: 'qwen-image-2512',
			name: 'Qwen Image 2512',
		},
		{
			id: 'gemini-25-flash-image',
			name: 'Gemini 2.5 Flash Image',
		},
		{
			id: 'gemini-25-flash-edit',
			name: 'Gemini 2.5 Flash Edit',
		},
		{
			id: 'sora-2',
			name: 'Sora 2',
		},
		{
			id: 'wan-vace-long-reframe',
			name: 'Wan VACE Long Reframe',
		},
		{
			id: 'wan-vace-video-edit',
			name: 'Wan VACE Video Edit',
		},
		{
			id: 'pixverse-sound-effects',
			name: 'Pixverse Sound Effects',
		},
		{
			id: 'wan-animate-move',
			name: 'Wan Animate Move',
		},
		{
			id: 'mmaudio-v2',
			name: 'MMAudio V2',
		},
		{
			id: 'sync-lipsync-v3',
			name: 'Sync Lipsync V3',
		},
		{
			id: 'emu-35',
			name: 'Emu 3.5',
		},
		{
			id: 'chrono-edit',
			name: 'Chrono Edit',
		},
		{
			id: 'flux-vision-upscaler',
			name: 'Flux Vision Upscaler',
		},
		{
			id: 'reve',
			name: 'Reve',
		},
		{
			id: 'nano-banana-pro',
			name: 'Nano Banana Pro',
		},
		{
			id: 'nano-banana-2',
			name: 'Nano Banana 2',
		},
		{
			id: 'gpt-image-2',
			name: 'GPT Image 2',
		},
		{
			id: 'gpt-image-2-5-flare',
			name: 'GPT Image 2.5 Flare',
		},
		{
			id: 'gpt-image-2-5-sunburst',
			name: 'GPT Image 2.5 Sunburst',
		},
		{
			id: 'nano-banana-2-lite',
			name: 'Nano Banana 2 Lite',
		},
		{
			id: 'nano-banana-2-1',
			name: 'Nano Banana 2.1',
		},
		{
			id: 'gemini-3-pro-image-preview',
			name: 'Gemini 3 Pro Image Preview',
		},
		{
			id: 'seedvr-upscale-video',
			name: 'SeedVR Upscale Video',
		},
		{
			id: 'flux-2-max',
			name: 'Flux 2 Max',
		},
		{
			id: 'flux-2-klein-4b',
			name: 'Flux 2 [klein] 4B',
		},
		{
			id: 'flux-2-klein-4b-distilled',
			name: 'Flux 2 [klein] 4B Distilled',
		},
		{
			id: 'flux-2-klein-9b',
			name: 'Flux 2 [klein] 9B',
		},
		{
			id: 'wan-3.0',
			name: 'Wan 3.0',
		},
		{
			id: 'wan-3.0-reference-video',
			name: 'Wan 3.0 Reference to Video',
		},
		{
			id: 'wan-3.0-prime',
			name: 'Wan 3.0 Prime',
		},
		{
			id: 'wan-3.0-prime-reference-video',
			name: 'Wan 3.0 Prime Reference to Video',
		},
		{
			id: 'wan-26',
			name: 'Wan 2.6',
		},
		{
			id: 'wan-26-reference-video',
			name: 'Wan 2.6 Reference Video',
		},
		{
			id: 'wan-27-edit-video',
			name: 'Wan 2.7 Edit Video',
		},
		{
			id: 'recraft-vectorize',
			name: 'Recraft Vectorize',
		},
		{
			id: 'meshy-v6-multi-image-to-3d',
			name: 'Meshy v6 Multi-Image to 3D',
		},
		{
			id: 'meshy-v7',
			name: 'Meshy v7',
		},
		{
			id: 'trellis-2',
			name: 'Trellis 2',
		},
		{
			id: 'tripo-h31-to-3d',
			name: 'Tripo H3.1 to 3D',
		},
		{
			id: 'hunyuan-3d-v31-pro-to-3d',
			name: 'Hunyuan 3D Pro to 3D',
		},
		{
			id: 'hi3d-v3-to-3d',
			name: 'Hi3D v3.0 to 3D',
		},
		{
			id: 'hyper3d-rodin',
			name: 'Hyper3D Rodin',
		},
	],
	[RUNNIT_NODE_DEF_PROVIDER.FREEPIK]: [
		{
			id: null,
			name: '---',
		},
		{
			id: 'magnific',
			name: 'Magnific',
		},
	],
	[RUNNIT_NODE_DEF_PROVIDER.KIEAI]: [
		{
			id: null,
			name: '---',
		},
		{
			id: 'nano-banana-pro',
			name: 'Nano Banana Pro (Kie.ai)',
		},
		{
			id: 'nano-banana-2',
			name: 'Nano Banana 2 (Kie.ai)',
		},
		{
			id: 'nano-banana-2-1',
			name: 'Nano Banana 2.1 (Kie.ai)',
		},
		{
			id: 'nano-banana-2-lite',
			name: 'Nano Banana 2 Lite (Kie.ai)',
		},
		{
			id: 'gpt-image-2',
			name: 'GPT Image 2 (Kie.ai)',
		},
		{
			id: 'kling-2-5-turbo-pro',
			name: 'Kling 2.5 Turbo Pro (Kie.ai)',
		},
		{
			id: 'kling-3-0-std',
			name: 'Kling 3.0 Standard (Kie.ai)',
		},
		{
			id: 'kling-3-0-pro',
			name: 'Kling 3.0 Pro (Kie.ai)',
		},
		{
			id: 'kling-3-0-4k',
			name: 'Kling 3.0 4K (Kie.ai)',
		},
	],
	[RUNNIT_NODE_DEF_PROVIDER.VERTEX]: [
		{
			id: null,
			name: '---',
		},
		{
			id: 'vertex-nano-banana',
			name: 'Nano Banana (Gemini Image)',
		},
		{
			id: 'vertex-veo',
			name: 'Veo (Video)',
		},
	],
	[RUNNIT_NODE_DEF_PROVIDER.OCTOAI]: [
		{
			id: null,
			name: '---',
		},
		{
			id: 'stable-diffusion-xl',
			name: 'Stable Diffusion XL',
		},
	],
	[RUNNIT_NODE_DEF_PROVIDER.RUNWARE]: [
		{
			id: null,
			name: '---',
		},
		{
			id: 'generate',
			name: 'Generate',
		},
		{
			id: 'generate-2',
			name: 'Generate (No NSFW)',
		},
		{
			id: 'generate-image-async',
			name: 'Generate Image Async',
		},
		{
			id: 'video-generate',
			name: 'Video Generate',
		},
		{
			id: 'controlnet-preprocess',
			name: 'ControlNet Preprocess',
		},
		{
			id: 'controlnet-generation',
			name: 'ControlNet Generation',
		},
		{
			id: 'background-removal',
			name: 'Background Removal',
		},
		{
			id: 'emoji',
			name: 'Emoji Generator',
		},
		{
			id: 'nbpro-face-swap',
			name: 'NBPro Face Swap',
		},
	],
	[RUNNIT_NODE_DEF_PROVIDER.RUNPOD]: [
		{
			id: null,
			name: '---',
		},
		{
			id: 'fooocus',
			name: 'Foooocus',
		},
	],
	[RUNNIT_NODE_DEF_PROVIDER.IDEOGRAM]: [
		{
			id: null,
			name: '---',
		},
		{
			id: 'generate',
			name: 'Generate',
		},
		{
			id: 'generate-v3',
			name: 'Generate V3',
		},
		{
			id: 'edit',
			name: 'Edit',
		},
		{
			id: 'edit-v3',
			name: 'Edit V3',
		},
		{
			id: 'reframe-v3',
			name: 'Reframe V3',
		},
		{
			id: 'remix-v3',
			name: 'Remix V3',
		},
		{
			id: 'replace-background-v3',
			name: 'Replace Background V3',
		},
		{
			id: 'upscale',
			name: 'Upscale',
		},
	],
	[RUNNIT_NODE_DEF_PROVIDER.NICHETENSOR]: [
		{
			id: null,
			name: '---',
		},
		{
			id: 'dalle',
			name: 'DallE',
		},
	],
	[RUNNIT_NODE_DEF_PROVIDER.RUNWAY]: [
		{
			id: null,
			name: '---',
		},
		{
			id: 'image_to_video',
			name: 'Image To Video',
		},
	],
	[RUNNIT_NODE_DEF_PROVIDER.LUMAAI]: [
		{
			id: null,
			name: '---',
		},
		{
			id: 'video_generation',
			name: 'Video Generation',
		},
	],
	[RUNNIT_NODE_DEF_PROVIDER.KLINGAI]: [
		{
			id: null,
			name: '---',
		},
		{
			id: 'kling-video-generation',
			name: 'Kling Video Generation (NON-FUNCTIONAL)',
		},
	],
	[RUNNIT_NODE_DEF_PROVIDER.MODAL]: [
		{
			id: null,
			name: '---',
		},
		{
			id: 'modal-training-1',
			name: 'Modal Training',
		},
		{
			id: 'image-to-layers',
			name: 'Layer Workflow',
		},
		{
			id: 'qwen-layers',
			name: 'Qwen Layers (Image Layered → PSD)',
		},
		{
			id: 'seedream-v5-pro-layerize',
			name: 'Seedream V5 Pro Layerize (Image Layered → PSD)',
		},
		{
			id: 'ltx-video',
			name: 'LTX Video',
		},
		{
			id: 'video-stitch',
			name: 'Video Stitch (FFmpeg)',
		},
	],
	[RUNNIT_NODE_DEF_PROVIDER.OPENAI]: [
		{
			id: null,
			name: '---',
		},
		{
			id: 'gpt-image',
			name: 'GPT Image Generation',
		},
	],
	[RUNNIT_NODE_DEF_PROVIDER.TOPAZ]: [
		{
			id: null,
			name: '---',
		},
		{
			id: 'enhance-async',
			name: 'Enhance',
		},
		{
			id: 'sharpen-async',
			name: 'Sharpen',
		},
		{
			id: 'enhance-gen-async',
			name: 'Generative Enhance',
		},
		{
			id: 'sharpen-gen-async',
			name: 'Generative Sharpen',
		},
		{
			id: 'denoise-async',
			name: 'Denoise',
		},
	],
};
